export * from "./StaticValuePicker";
